import { CHANGE_PASSWORD, CHANGE_PASSWORD_ERROR } from "../types";

const initialState = {
  changePasswordInfo: {},
  loading: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CHANGE_PASSWORD:
      return {
        ...state,
        changePasswordInfo: action.payload,
        loading: false,
      };
    case CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
}
